export default __webpack_public_path__ + "static/media/Document icon.ca459d06.png";